import { render, staticRenderFns } from "./CreateAccount_2.vue?vue&type=template&id=7290f5d4&scoped=true&"
import script from "./CreateAccount_2.vue?vue&type=script&lang=js&"
export * from "./CreateAccount_2.vue?vue&type=script&lang=js&"
import style0 from "./CreateAccount_2.vue?vue&type=style&index=0&id=7290f5d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7290f5d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
